import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const style = StyleSheet.create({
  container: theme => ({
    backgroundColor: theme.colors.backgroundColorThree,
    padding: 16,
    flex: 2,
  }),
  iconStyle: {
    resizeMode: 'contain',
  },
  detailsContainer: {
    flexDirection: 'row',
    marginBottom: '3.7%',
  },
  detailsWrapper: {
    marginTop: 10,
    flex: 1,
    paddingLeft: 52,
  },
  detailItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 4.2,
  },
  detailKey: {
    fontSize: 18,
    lineHeight: 23,
  },
  detailValue: {
    fontSize: 18,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleSubTitleContainer: {
    marginLeft: 20,
  },
  title: theme => ({
    marginBottom: 1,
    fontSize: 16,
    lineHeight: 18.8,
    color: theme.colors.orderSummaryTitle,
  }),
  subTitle: {
    fontSize: 20,
    lineHeight: 25.1,
    ...Fonts.type.bold,
  },
});
export default style;
